import { ComponentType } from 'preact'
import { YogaWidgetBase, InitData } from '../../core'
import { UpcomingClassesWidget } from './UpcomingClassesWidget'

class HoldstyringUpcomingClassesElement extends YogaWidgetBase {
  protected getComponent(): ComponentType<{ initData: InitData }> {
    return UpcomingClassesWidget
  }

  // Supported HTML attributes:
  //   limit="6"           — number of upcoming classes to show (1-30, default: 6)
  //   title="..."         — heading above the cards (default: none)
  //   guests-only="true"  — gæste-fokuseret booking (stepperen vises åben); medlemmet
  //                         kan stadig booke sig selv uden gæster.
  protected getWidgetProps() {
    const raw = this.getAttribute('limit')
    const parsed = raw && /^\d+$/.test(raw) ? parseInt(raw, 10) : 6
    return {
      limit: parsed,
      title: this.getAttribute('title') || null,
      guestsOnly: this.getAttribute('guests-only') === 'true',
    }
  }
}

if (!customElements.get('holdstyring-upcoming-classes')) {
  customElements.define('holdstyring-upcoming-classes', HoldstyringUpcomingClassesElement)
}

export { HoldstyringUpcomingClassesElement }
